module.exports = __webpack_public_path__ + "static/assets/de2e608d3204eebd05d29d01c3898d50.png";